import { render } from "./AnagraficaClienti.vue?vue&type=template&id=2e7c5460&scoped=true"
import script from "./AnagraficaClienti.vue?vue&type=script&lang=js"
export * from "./AnagraficaClienti.vue?vue&type=script&lang=js"

import "./AnagraficaClienti.vue?vue&type=style&index=0&id=2e7c5460&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7c5460"]])

export default __exports__